export const STEPS = [
  {
    id: 1,
    title: 'Info',
    step: 1,
  },
  {
    id: 2,
    title: 'OTP',
    step: 2,
  },
];
